var vP12050 = require("./27.js");
var vP120502 = require("./62.js");
const vObject = Object(vP120502.b)();
const vLN802 = 80;
function f1504(p12051, p12052 = {}) {
  try {
    let vP12051 = p12051;
    const vA525 = [];
    let vLN01531 = 0;
    let vLN01532 = 0;
    const vLS37 = " > ";
    const v9398 = vLS37.length;
    let v9399;
    const v9400 = Array.isArray(p12052) ? p12052 : p12052.keyAttrs;
    const v9401 = !Array.isArray(p12052) && p12052.maxStringLength || vLN802;
    while (vP12051 && vLN01531++ < 5 && (v9399 = f1505(vP12051, v9400), v9399 !== "html" && (!(vLN01531 > 1) || !(vLN01532 + vA525.length * v9398 + v9399.length >= v9401)))) {
      vA525.push(v9399);
      vLN01532 += v9399.length;
      vP12051 = vP12051.parentNode;
    }
    return vA525.reverse().join(vLS37);
  } catch (e85) {
    return "<unknown>";
  }
}
function f1505(p12053, p12054) {
  const vP12053 = p12053;
  const vA526 = [];
  let v9402;
  let v9403;
  let v9404;
  let v9405;
  let v9406;
  if (!vP12053 || !vP12053.tagName) {
    return "";
  }
  vA526.push(vP12053.tagName.toLowerCase());
  const v9407 = p12054 && p12054.length ? p12054.filter(p12055 => vP12053.getAttribute(p12055)).map(p12056 => [p12056, vP12053.getAttribute(p12056)]) : null;
  if (v9407 && v9407.length) {
    v9407.forEach(p12057 => {
      vA526.push("[" + p12057[0] + "=\"" + p12057[1] + "\"]");
    });
  } else {
    if (vP12053.id) {
      vA526.push("#" + vP12053.id);
    }
    v9402 = vP12053.className;
    if (v9402 && Object(vP12050.i)(v9402)) {
      v9403 = v9402.split(/\s+/);
      v9406 = 0;
      for (; v9406 < v9403.length; v9406++) {
        vA526.push("." + v9403[v9406]);
      }
    }
  }
  const vA527 = ["aria-label", "type", "name", "title", "alt"];
  for (v9406 = 0; v9406 < vA527.length; v9406++) {
    v9404 = vA527[v9406];
    v9405 = vP12053.getAttribute(v9404);
    if (v9405) {
      vA526.push("[" + v9404 + "=\"" + v9405 + "\"]");
    }
  }
  return vA526.join("");
}
function f1506() {
  try {
    return vObject.document.location.href;
  } catch (e86) {
    return "";
  }
}
function f1507(p12058) {
  if (vObject.document && vObject.document.querySelector) {
    return vObject.document.querySelector(p12058);
  } else {
    return null;
  }
}
var vP120503 = require("./124.js");
function c(p12059, p12060, p12061) {
  if (!(p12060 in p12059)) {
    return;
  }
  const v9408 = p12059[p12060];
  const vP12061 = p12061(v9408);
  if (typeof vP12061 == "function") {
    try {
      f1510(vP12061, v9408);
    } catch (e87) {}
  }
  p12059[p12060] = vP12061;
}
exports.c = c;
function a(p12062, p12063, p12064) {
  Object.defineProperty(p12062, p12063, {
    value: p12064,
    writable: true,
    configurable: true
  });
}
exports.a = a;
function f1510(p12065, p12066) {
  const v9409 = p12066.prototype || {};
  p12065.prototype = p12066.prototype = v9409;
  a(p12065, "__sentry_original__", p12066);
}
function f1511(p12067) {
  return p12067.__sentry_original__;
}
function f1512(p12068) {
  return Object.keys(p12068).map(p12069 => encodeURIComponent(p12069) + "=" + encodeURIComponent(p12068[p12069])).join("&");
}
function b(p12070) {
  if (Object(vP12050.b)(p12070)) {
    return {
      message: p12070.message,
      name: p12070.name,
      stack: p12070.stack,
      ...f1515(p12070)
    };
  }
  if (Object(vP12050.c)(p12070)) {
    const vO297 = {
      type: p12070.type,
      target: f1514(p12070.target),
      currentTarget: f1514(p12070.currentTarget),
      ...f1515(p12070)
    };
    if (typeof CustomEvent != "undefined" && Object(vP12050.d)(p12070, CustomEvent)) {
      vO297.detail = p12070.detail;
    }
    return vO297;
  }
  return p12070;
}
exports.b = b;
function f1514(p12071) {
  try {
    if (Object(vP12050.a)(p12071)) {
      return f1504(p12071);
    } else {
      return Object.prototype.toString.call(p12071);
    }
  } catch (e88) {
    return "<unknown>";
  }
}
function f1515(p12072) {
  if (typeof p12072 == "object" && p12072 !== null) {
    const vO298 = {};
    for (const v9410 in p12072) {
      if (Object.prototype.hasOwnProperty.call(p12072, v9410)) {
        vO298[v9410] = p12072[v9410];
      }
    }
    return vO298;
  }
  return {};
}
function f1516(p12073, p12074 = 40) {
  const v9411 = Object.keys(b(p12073));
  v9411.sort();
  if (!v9411.length) {
    return "[object has no keys]";
  }
  if (v9411[0].length >= p12074) {
    return Object(vP120503.c)(v9411[0], p12074);
  }
  for (let v9412 = v9411.length; v9412 > 0; v9412--) {
    const v9413 = v9411.slice(0, v9412).join(", ");
    if (!(v9413.length > p12074)) {
      if (v9412 === v9411.length) {
        return v9413;
      } else {
        return Object(vP120503.c)(v9413, p12074);
      }
    }
  }
  return "";
}
function f1517(p12075) {
  const v9414 = new Map();
  return f1518(p12075, v9414);
}
function f1518(p12076, p12077) {
  if (Object(vP12050.f)(p12076)) {
    const v9415 = p12077.get(p12076);
    if (v9415 !== undefined) {
      return v9415;
    }
    const vO299 = {};
    p12077.set(p12076, vO299);
    for (const v9416 of Object.keys(p12076)) {
      if (typeof p12076[v9416] != "undefined") {
        vO299[v9416] = f1518(p12076[v9416], p12077);
      }
    }
    return vO299;
  }
  if (Array.isArray(p12076)) {
    const v9417 = p12077.get(p12076);
    if (v9417 !== undefined) {
      return v9417;
    }
    const vA528 = [];
    p12077.set(p12076, vA528);
    p12076.forEach(p12078 => {
      vA528.push(f1518(p12078, p12077));
    });
    return vA528;
  }
  return p12076;
}
function f1519(p12079) {
  let v9418;
  switch (true) {
    case p12079 === undefined || p12079 === null:
      v9418 = new String(p12079);
      break;
    case typeof p12079 == "symbol" || typeof p12079 == "bigint":
      v9418 = Object(p12079);
      break;
    case Object(vP12050.g)(p12079):
      v9418 = new p12079.constructor(p12079);
      break;
    default:
      v9418 = p12079;
  }
  return v9418;
}